"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M12 23c-1.526 0-2.957-.288-4.295-.866a11.1 11.1 0 0 1-3.49-2.35 11.1 11.1 0 0 1-2.35-3.49A10.723 10.723 0 0 1 1 12c0-1.526.289-2.957.866-4.295a11.1 11.1 0 0 1 2.35-3.49 11.1 11.1 0 0 1 3.49-2.35A10.723 10.723 0 0 1 12 1c1.526 0 2.957.289 4.295.866a11.1 11.1 0 0 1 3.49 2.35 11.1 11.1 0 0 1 2.35 3.49C22.71 9.042 23 10.473 23 12c0 1.526-.288 2.957-.866 4.295a11.099 11.099 0 0 1-2.35 3.49 11.095 11.095 0 0 1-3.49 2.35A10.723 10.723 0 0 1 12 23Zm0-2.453c2.39 0 4.413-.827 6.067-2.48 1.653-1.654 2.48-3.677 2.48-6.067s-.827-4.413-2.48-6.067C16.413 4.28 14.39 3.453 12 3.453s-4.413.827-6.067 2.48C4.28 7.587 3.453 9.61 3.453 12s.827 4.413 2.48 6.067c1.654 1.653 3.676 2.48 6.067 2.48Z"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M10.648 14.244c-.17-1.13-.031-1.81 1.006-2.817.68-.665 1.238-1.3 1.238-2.136 0-.696-.495-1.052-1.16-1.052-.837 0-1.394.31-1.796.727h-.867V7.295c.712-.48 1.61-.82 2.801-.82 2.12 0 3.406.943 3.406 2.8 0 1.177-.573 1.905-1.58 2.725-.928.774-1.516 1.176-1.439 2.244h-1.61Zm.882 3.282c-.712 0-1.27-.542-1.27-1.238 0-.697.558-1.254 1.27-1.254.696 0 1.27.557 1.27 1.254 0 .696-.574 1.238-1.27 1.238Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};